// 引入样式
require('./list.less');
// 加载基类
let DblClass = require('dbl-class');
// 加载弹框组件
let dbl_dialog = require('dbl-dialog');
// 表单组件
let creatFormList = require('../contactForm/form');
//URL常量
let urls = {
  ajaxUrl: `//${contactTemplate.baseUri}/contacttemplate/contactTmplApi/queryContactTemplateList.json`,
  ajaxQueryUrl: `//${contactTemplate.queryUri}/ContactTemplateApi/queryContactTemplateExt.jsonp`,
  ajaxSaveTemUrl:`//${contactTemplate.queryUri}/ContactTemplateApi/saveContactTemplateExt.jsonp`,
  ajaxViewUrl: `//${contactTemplate.baseUri}/contacttemplate/contactTmplApi/queryContactTemplateInfo.json`,
  ajaxSaveUrl: `//${contactTemplate.baseUri}/contacttemplate/contactTmplApi/saveContactTemplate.json`,
  ajaxEditUrl: `//${contactTemplate.baseUri}/contacttemplate/contactTmplApi/saveContactTemplate.json`,
  ajaxTplNumURL: `//${contactTemplate.baseUri}/contacttemplate/contactTmplApi/queryContactTemplateCount.json`
};
// console.log('urls', urls);

var infoList = DblClass.createClass({
  // 模板
  tpl: require('./list.ejs'),
  // 构造函数
  constructor: function (data) {
    // 合并数据
    this.extendCfg(data);
    // 渲染元素 var html = require('./list.ejs'); $('#domain_contact_list').html(html);
    // 绑定事件
    this.__bindEvents__(this.events);
  },
  // 扩展配置
  extendCfg: function (data) {
    var data = data || {};
    data = $.extend(true, {}, urls, this.config, data);
    this.config = data;
    if (this.config.selectId) {
      this.el = $('#' + this.config.selectId);
    }
    this.foldClose = !this.config.defaultFoldList;
  },
  // 绑定事件
  events: {
    // 'click .add-template': 'addTemplate',
    'click .fold-list': 'foldList',
    'click .template-id': 'selectDefaultTmp',
    'click .view-detail': 'viewDetail',
    'click .current-page': 'pagination'
  },
  // 保存或编辑信息模板
  saveOrUpdateTemplate: function (formObj) {
    let self = this;
    let template = formObj.getFormData();
    let statues = ["FAILED", "SUCCEED", "NONAUDIT", "AUDITING"]
    let saveobj = {
      "zhCity": template.c_city,
      "createTime": template.createTime,
      "registrantProfileId": template.id,
      "zhAddress": template.c_venu,
      "emailVerificationStatus": template.emailVerificationStatus,
      "updateTime": template.updateTime,
      "defaultRegistrantProfile": template.defaultTemplate,
      "telArea": template.telArea,
      "zhProvince": template.c_province,
      "registrantType": template.regType,
      "city": template.e_city,
      "country": template.c_country,
      "registrantOrganization": template.e_company,
      "postalCode": template.postalcode,
      "registrantName": template.e_name,
      "address": template.e_venu,
      "email": template.email,
      "zhRegistrantOrganization": template.c_company,
      "province": template.e_province,
      "telephone": template.telMain,
      "zhRegistrantName": template.c_name,
      "realNameStatus": statues[template.auditStatus]
    }
    // template.validation = 1;
    // let url;
    // if (!template.id) {
    //   url = self.config.ajaxSaveUrl;
    // } else {
    //   url = self.config.ajaxEditUrl;
    // }
    self
      .ajaxRequest({ url: self.config.ajaxSaveTemUrl, type: 'post', data: saveobj })
      .then(function (data) {
        // 显示返回结果
        if (data.code != '200') {
          if (data.code == '150001') {
            alert('亲，超过信息模版数量限制，请删除或修改已创建信息模版。');
          } else {
            alert('保存域名信息模板错误，请重试');
          }
          return;
        }
        // let id;
        // if (!template.id) {
        //   id = data.data;
        //   self
        //     .ajaxRequest({
        //       url: self.config.ajaxViewUrl,
        //       type: 'get',
        //       data: {
        //         id: id
        //       }
        //     })
        //     .then(function (data) {
        //       // 显示返回结果
        //       if (data.code != '200') {
        //         alert('查询域名信息模板错误，请重试');
        //         return;
        //       }
        //       let template = data.data;
        //       if (self.config.filterStatus) {
        //         template = Boolean(template.auditStatus && template.auditStatus == 1) || false;
        //       }
        //       if (template) {
        //         if (!self[self.regType].templates) {
        //           self[self.regType].templates = [];
        //         }
        //         self[self.regType]
        //           .templates
        //           .splice(0, 0, template);
        //         //self[self.regType].selectTemplate = template;
        //         self.render(self.regType);
        //       }
        //     });
        // } else {
        //   id = template.id;
        //   self
        //     .ajaxRequest({
        //       url: self.config.ajaxViewUrl,
        //       type: 'get',
        //       data: {
        //         id: id
        //       }
        //     })
        //     .then(function (data) {
        //       // 显示返回结果
        //       if (data.code != '200') {
        //         alert('查询域名信息模板错误，请重试');
        //         return;
        //       }
        //       let newtemplate = data.data;
        //       if (newtemplate) {
        //         for (let i = 0; i < self[self.regType].templates.length; i++) {
        //           let template = self[self.regType].templates[i];
        //           if (newtemplate.id == template.id) {
        //             self[self.regType].templates[i] = newtemplate;
        //           } else if (newtemplate.defaultTemplate == '1' && newtemplate.regType == template.regType && template.defaultTemplate == '1') {
        //             template.defaultTemplate == 0;
        //           }
        //         }
        //         //self[self.regType].selectTemplate = newtemplate;
        //         self.render(self.regType);
        //       }
        //     });
        // }
      })
      .fail(function () {
        alert('保存域名信息模板错误，请重试');
      });
  },
  defaultAjaxReq: {
    url: null,
    type: 'post',
    dataType: 'jsonp',
    async: false,
    jsonp: 'callback',
    data: null
  },
  // 异步请求方法
  ajaxRequest: function (ajaxReq) {
    ajaxReq = $.extend(true, {}, this.defaultAjaxReq, ajaxReq);
    let ajaxOptions = $.ajax(ajaxReq);
    return $.when(ajaxOptions);
  },
  // 添加模板方法
  addTemplate: function (e) {
    // 表单模板对象
    let self = this;
    infoList
      .getContactTemplateCount1()
      .success(function (count) {
        if (count < (self.config.templateLimit || 500)) {
          let regTypeVal = self.regType;
          if (regTypeVal != 1 && regTypeVal != 2) {
            regTypeVal = 1;
          }
          let formObj = new creatFormList({ selectId: 'addTemplate_contactForm', displayMode: 1, regType: regTypeVal });
          formObj.popup({
            callback: function (obj) {
              return self.saveOrUpdateTemplate(obj);
            }
          });
        } else {
          alert('亲，超过信息模版数量限制，请删除或修改已创建信息模版。');
          // alert("亲，最多创建" + (self.config.templateLimit || 20) +
          // "个域名信息模版哟，请删除或修改已创建信息模版。");
        }
      });
  },
  // 收起方法
  foldClose: true,
  foldList: function (e) {
    let self = this;
    let obj = $(e.target);
    this.foldClose = !this.foldClose;
    this.render(this.regType);
  },
  // 查看详情方法
  viewDetail: function (e) {
    let self = this;
    let id = $(e.target).attr('data-id');
    self
      .ajaxRequest({
        url: self.config.ajaxQueryUrl,
        type: 'get',
        data: {
          registrantProfileId: id
        }
      })
      .then(function (data) {
        // 显示返回结果
        if (data.code != '200') {
          alert('查询域名信息模板错误，请重试');
          return;
        }
        console.log(data)
        let template = data.data.registrantProfiles[0];
        const status = {
          "FAILED": 0,
          "SUCCEED": 1,
          "NONAUDIT": 2,
          "AUDITING": 3
        }
        let newobj = {
          c_city: template.zhCity,
          c_company: template.zhRegistrantOrganization,
          c_country: template.country,
          c_name: template.zhRegistrantName,
          c_province: template.zhProvince,
          c_venu: template.zhAddress,
          createTime: template.createTime,
          defaultTemplate: template.defaultRegistrantProfile,
          e_city: template.city,
          e_company: template.registrantOrganization,
          e_name: template.registrantName,
          e_province: template.province,
          e_venu: template.address,
          email: template.email,
          emailVerificationStatus: template.emailVerificationStatus,
          id: template.registrantProfileId,
          postalcode: template.postalCode,
          regType: template.registrantType,
          telArea: template.telArea,
          telMain: template.telephone,
          updateTime: template.updateTime,
          auditStatus: status[template.realNameStatus]
        }
        let formObj = new creatFormList({ selectId: 'viewDetail_contactForm', displayMode: 1, regType: self.regType });
        formObj.popup({
          data: newobj,
          callback: function (obj) {
            return self.saveOrUpdateTemplate(obj);
          }
        });

      })
      .fail(function () {
        alert('查询域名信息模板错误，请重试');
      });

    // var template = self.getContactTemplateFromList(self.regType,id); var formObj =
    // new
    // creatFormList({selectId:"viewDetail_contactForm",displayMode:1,regType:self.re
    // gType}); formObj.popup({data:template,callback:function(obj){return
    // self.saveOrUpdateTemplate(obj);}});
  },
  getContactTemplateFromList: function (regType, id) {
    let self = this;
    if (self.regType && self[self.regType] && self[self.regType].templates) {
      for (let i = 0; i < self[self.regType].templates.length; i++) {
        let template = self[self.regType].templates[i];
        if (id == template.id) {
          return template;
        }
      }
    }
  },
  getContactTemplateIndexFromList: function (regType, id) {
    let self = this;
    if (self.regType && self[self.regType] && self[self.regType].templates) {
      for (let i = 0; i < self[self.regType].templates.length; i++) {
        let template = self[self.regType].templates[i];
        if (id == template.id) {
          return i;
        }
      }
    }
  },
  // 选择默认模板
  selectDefaultTmp: function (e) {
    let id = $(e.target).val();
    let self = this;
    for (let i = 0; i < self[self.regType].templates.length; i++) {
      let template = self[self.regType].templates[i];
      if (id == template.registrantProfileId) {
        const popstatus = {
          "FAILED": 0,
          "SUCCEED": 1,
          "NONAUDIT": 2,
          "AUDITING": 3
        }
        let selectobj = {
          c_city: template.zhCity,
          c_company: template.zhRegistrantOrganization,
          c_country: template.country,
          c_name: template.zhRegistrantName,
          c_province: template.zhProvince,
          c_venu: template.zhAddress,
          createTime: template.createTime,
          defaultTemplate: template.defaultRegistrantProfile,
          e_city: template.city,
          e_company: template.registrantOrganization,
          e_name: template.registrantName,
          e_province: template.province,
          e_venu: template.address,
          email: template.email,
          emailVerificationStatus: template.emailVerificationStatus,
          id: template.registrantProfileId,
          postalcode: template.postalCode,
          regType: template.registrantType,
          telArea: template.telArea,
          telMain: template.telephone,
          updateTime: template.updateTime,
          auditStatus: popstatus[template.realNameStatus]
        }       
         self[self.regType].selectTemplate = selectobj;
        if (self.config.selectContactTemplateCallback) {
          self
            .config
            .selectContactTemplateCallback(selectobj);
        }
        break;
      }
    }

  },
  onSelectContactTemplate: function (callback) {
    if (callback && typeof callback === 'function') {
      this.config.selectContactTemplateCallback = callback;
    }
  },
  // 默认配置
  config: {
    selectId: '',
    defaultSelect: true,
    defaultFoldList: false,
    selectContactTemplateCallback: function (contactTemplate) { }
  },
  // 分页
  pagination: function (e) {
    let self = this;
    let nextpage = $(e.target).attr("value");
    self.render(self.regType, nextpage);
  },
  // 渲染元素
  render: function (regType, nextpage) {
    // debugger;
    // console.log('list render ' + regType);
    let self = this;
    // loading
    if (!regType && !self.regType) {
      return;
    } else if (regType) {
      self.regType = regType;
    }
    if (!self[self.regType] || nextpage) {
      // ajax 配置
      let ajaxReq = {};
      if (self.config.filterStatus) {
        ajaxReq = {
          url: self.config.ajaxQueryUrl,
          type: 'get',
          data: nextpage
            ? {
              currentPage: nextpage,
              pageSize: 10,
              realNameStatus: 'SUCCEED',
              registrantType: self.regType
            }
            : {
              currentPage: 1,
              pageSize: 10,
              realNameStatus: 'SUCCEED',
              registrantType: self.regType
            }
        };
      } else {
        ajaxReq = {
          url: self.config.ajaxQueryUrl,
          type: 'get',
          data: nextpage
            ? {
              currentPage: nextpage,
              pageSize: 10,
              registrantType: self.regType
            }
            : {
              currentPage: 1,
              pageSize: 10,
              registrantType: self.regType
            }
        };
      }
      // jsonp 获取数据
      self
        .ajaxRequest(ajaxReq)
        .then(function (data) {
          // 遍历默认模板
          let templates = data.data.registrantProfiles || [];
          let totalpage = data.data.totalPageNum || 0;
          let currentpage = data.data.currentPageNum || 1;
          // console.log(templates);
          //支持模板信息认证状态筛选
          if (self.config.filterStatus) {
            templates = templates.filter(function (info) {
              return info.realNameStatus && info.realNameStatus == 'SUCCEED';
            });
          }

          let defaultTemplate = null;
          if (self.config.defaultSelect && (self.regType == 1 || self.regType == 2)) {
            for (let i in templates) {
              if (templates[i].defaultRegistrantProfile == true) {
                defaultTemplate = templates[i];
                break;
              }
            }
          }
          self[self.regType] = {
            templates: templates,
            selectTemplate: null,
            totalpage: totalpage,
            currentpage: currentpage
          };
          // 模板绑定
          if (self[self.regType]) {
            let renderParams = {};
            renderParams.templates = self[self.regType].templates;
            renderParams.totalpage = self[self.regType].totalpage;
            renderParams.currentpage = self[self.regType].currentpage;
            renderParams.selectTemplate = self[self.regType].selectTemplate;
            renderParams.foldClose = self.foldClose;
            renderParams.config = self.config;
            let html = self.tpl(renderParams);
            // 渲染
            self
              .el
              .html(html);
            if (self.config.selectContactTemplateCallback && self[self.regType].selectTemplate) {
              self
                .config
                .selectContactTemplateCallback(self[self.regType].selectTemplate);
            }
          }
        });
    } else {
      let renderParams = {};
      renderParams.templates = self[self.regType].templates;
      renderParams.totalpage = self[self.regType].totalpage;
      renderParams.currentpage = self[self.regType].currentpage;
      renderParams.selectTemplate = self[self.regType].selectTemplate;
      renderParams.foldClose = self.foldClose;
      renderParams.config = self.config;
      let html = self.tpl(renderParams);
      // 渲染
      self
        .el
        .html(html);
      if (self.config.selectContactTemplateCallback && self[self.regType].selectTemplate) {
        self
          .config
          .selectContactTemplateCallback(self[self.regType].selectTemplate);
      }
    }

  },
  regType: null,
  isSelectContactTemplate: function () {
    return this.regType && this[this.regType] && this[this.regType].selectTemplate;
  },
  getSelectContactTemplate: function () {
    if (this.isSelectContactTemplate()) {
      return this[this.regType].selectTemplate;
    }
  }
});

//分类信息完整的模板
infoList.getContactTemplateCount = function (regType, callback) {
  let jqxhr = $.ajax({
    url: urls.ajaxTplNumURL,
    type: 'get',
    dataType: 'jsonp',
    async: false,
    cache: false,
    jsonp: 'callback',
    data: (regType === undefined || regType == 3)
      ? {
        validation: 1
      }
      : {
        regType: regType,
        validation: 1
      }
  });
  let retObj = {
    success: function (callback) {
      jqxhr
        .done(function (data) {
          if (data.code == 200) {
            callback(data.data);
          }
        });
    }
  };
  return retObj;
};

//所有模板
infoList.getContactTemplateCount1 = function (regType, callback) {

  let jqxhr = $.ajax({
    url: urls.ajaxTplNumURL,
    type: 'get',
    dataType: 'jsonp',
    async: false,
    cache: false,
    jsonp: 'callback'
  });
  let retObj = {
    success: function (callback) {
      jqxhr
        .done(function (data) {
          if (data.code == 200) {
            callback(data.data);
          }
        });
    }
  };
  return retObj;
};
module.exports = infoList;


// WEBPACK FOOTER //
// ./src/scripts/components/contactList/list.js